import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import WholeLoading from '../../../component/common/loading/WholeLoading.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import Pagination from '../../../component/common/dataGrid/Pagination.jsx';
import useModalStore from '../../../zustand/store/useModalStore.js';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js'

const BdExceptionAsk = () => {

    const userId = localStorage.getItem('id');
    
    const [isSearched, setIsSearched] = useState(false);
    const [isWholeLoading, setIsWholeLoading] = useState(false);
    const [checkItems, setCheckItems] = useState([]);
    const [dataList, setDataList] = useState([]);

    const [pageInfo, setPageInfo] = useState({
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
    });

    const [searchParams, setSearchParams] = useState({
        searchFromdate: '',
        searchTodate: '',
        searchEmog: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("useremcd") : '',
        searchGrdc: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emoggrdc2") : '',
        searchLoca: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emogloca") : '',
        searchGubun: 'ALL',
        searchIdno: '',
        pageNum: 1,
        displayRowsize: 50,
    });

    const [exceptionParams, setExceptionParams] = useState({
        arrayExcepSeq: [],
        emmkMemo: '',
    });

    useEffect(() => {
        const init = async () => {
            setIsWholeLoading(true);
            const { fromDate, toDate } = await getDefaultSearchDays();
            setSearchParams(prev => ({ ...prev, searchFromdate: fromDate, searchTodate: toDate }));
            setIsWholeLoading(false);
        };
        init();
    }, []);

    useEffect(() => {
        setSearchParams(prev => ({
            ...prev,
            pageNum: pageInfo.currentPage,
            displayRowsize: pageInfo.itemsPerPage,
        }));
        if (isSearched) fetchData();
    }, [pageInfo.currentPage, pageInfo.itemsPerPage]);

    const getDefaultSearchDays = async () => {
        try {
            const today = new Date();
            const currentDay = today.getDay(); // 0 (Sun) ~ 6 (Sat)
            const start = new Date(today);
            start.setDate(today.getDate() - currentDay - 6); // 지난주 월요일
            const end = new Date(today);
            end.setDate(today.getDate() - currentDay); // 지난주 일요일

            const { data } = await axios.post('/ptmiapi/sendweb/selectHolidayEMMK.do');
            if (data?.BNDSTTDT && data?.BNDENDDT) {
                return {
                    fromDate: formatDate(data.BNDSTTDT),
                    toDate: formatDate(data.BNDENDDT),
                };
            }

            return {
                fromDate: formatDateObj(start),
                toDate: formatDateObj(end),
            };
        } catch (error) {
            console.error('날짜 계산 오류:', error);
            return { fromDate: '', toDate: '' };
        }
    };

    const formatDate = (str) => {
        return `${str.substring(0, 4)}-${str.substring(4, 6)}-${str.substring(6, 8)}`;
    };

    const formatDateObj = (date) => {
        const y = date.getFullYear();
        const m = `${date.getMonth() + 1}`.padStart(2, '0');
        const d = `${date.getDate()}`.padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({ ...prev, [name]: value }));
        if (name === 'emmkMemo') {
            setExceptionParams(prev => ({ ...prev, emmkMemo: value }));
        }
    };

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const handleSearch = () => {
        if (!searchParams.searchEmog) {
            showNotiModal('먼저 해당 응급의료기관을 선택해주세요!');
            return;
        }
        setIsSearched(true);
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const fetchData = async () => {
        try {
            setIsWholeLoading(true);
            const { data } = await axios.get('/ptmiapi/sendweb/selectEMIMEMMKList2.do', { params: searchParams });
            setDataList(data);
            fetchDataCount();
        } catch (err) {
            console.error('데이터 로딩 오류:', err);
        } finally {
            setIsWholeLoading(false);
        }
    };

    const fetchDataCount = async () => {
        try {
            const { data } = await axios.get('/ptmiapi/sendweb/selectEMIMEMMKList2Cnt.do', { params: searchParams });
            setPageInfo(prev => ({ ...prev, totalItems: data }));
        } catch (err) {
            console.error('카운트 로딩 오류:', err);
        }
    };

    const handleAllCheck = (checked) => {
        setCheckItems(checked ? [...dataList] : []);
    };

    const handleSingleCheck = (checked, item) => {
        setCheckItems(prev =>
            checked ? [...prev, item] : prev.filter(ci => ci.SEQ !== item.SEQ)
        );
    };

    const handlePerPageChange = (e) => {
        setPageInfo(prev => ({ ...prev, itemsPerPage: parseInt(e.target.value) }));
    };

    const exceptionList = (items) =>
        items.map(el => `${el.ERROEMCD}|${el.ERROIDNO}|${el.ERROINDT}|${el.ERROINTM}|${el.ERROWRDT}|*`);

    const handleExceptionSubmit = async () => {
        if (checkItems.length === 0) {
            showNotiModal("예외전송 신청을 처리할 항목을 선택해주세요!");
            return;
        } else {
            const confirmed = window.confirm("예외신청을 진행하시겠습니까?");
            if (!confirmed) {
                // 취소 누르면 함수 종료
                return;
            }
            try {
                const { data } = await axios.post('/ptmiapi/sendweb/exceptAskProc.do', {
                    arrayExcepSeq: exceptionList(checkItems),
                    emmkMemo: exceptionParams.emmkMemo,
                    userId: localStorage.getItem("id"),
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                if (!data.hasError) {
                    alert(data.resultMessage);
                    setCheckItems([]);
                    handleSearch();
                } else {
                    alert(data.resultMessage);
                    return;
                }
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    // 서버가 에러 메시지를 응답한 경우
                    const message = error.response.data?.message || "서버 내부 오류가 발생했습니다.";
                    alert(`오류: ${message}`);
                } else {
                    const errMsg =
                        error.response.data?.message || // JSON 형식일 경우
                        error.response.data ||          // 텍스트 형식일 경우
                        "알 수 없는 오류가 발생했습니다.";
                    alert(`오류: ${errMsg}`);
                }
                console.error('예외 요청 중 오류:', error);
            }
        }
    };

    const perPageOptions = Array.from({ length: 10 }, (_, i) => (i + 1) * 10);
    const tableHeaders = ['No', '기관명', '기관코드', '등록번호', '내원일자', '내원시간', '오류일자', '오류시간'];
    const tableFields = ['SEQ', 'EMOGDESC', 'ERROEMCD', 'ERROIDNO', 'ERROINDT', 'ERROINTM', 'ERROWRDT', 'ERROWRTM'];

    // Dynamic Style Hook
    const { fontColor, primaryBackColor, lightBackColor, borderColorGray, hoverLightFontColor } = useDynamicStyle();

    const noticePopup = () => {
        let popup = null;
        popup = window.open('/nedis/exception/Bdexception_notice_popup.do', "팝업", "scrollbars=0, resizable=0, width=650, height=650, top=30, left=30");
    }

    useEffect(() => {
        const today = new Date().toISOString().slice(0, 10);
        const storageKey = `pophide_bdException_${userId}`;
        const saved = localStorage.getItem(storageKey);

        if (saved !== today) {
            noticePopup();
        }
    }, []);

    return (
        <Main>
            {isWholeLoading && <WholeLoading />}
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="8%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                exValidation={true}
                            />
                        </tr>
                        <tr>
                            <th>내원일시</th>
                            <td>
                                <input type="date" name="searchFromdate" value={searchParams.searchFromdate} disabled />
                                &nbsp;~&nbsp;
                                <input type="date" name="searchTodate" value={searchParams.searchTodate} disabled />
                            </td>
                            <th>구분</th>
                            <td>
                                <select name="searchGubun" className='w-full' value={searchParams.searchGubun} onChange={handleInputChange}>
                                    {['ALL', 'A', 'G', 'B', 'Y', 'S', 'N', 'Z', 'D', 'E'].map(code => (
                                        <option key={code} value={code}>{code === 'ALL' ? '전체' : code === 'A' ? '생성' : code === 'G' ? '퇴실완료' : code === 'B' ? '퇴실재검토필요' : code === 'Y' ? '퇴실재검토완료' : code === 'S' ? '퇴원완료' : code === 'N' ? '퇴원재검토필요' : code === 'Z' ? '퇴원재검토완료' : code === 'D' ? '삭제' : '오류'}</option>
                                    ))}
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input type="text" id='searchIdno' name="searchPtmiIdno" value={searchParams.searchIdno} onChange={handleInputChange} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='search_btn_wrapper'>
                <div className='flex wp-60'>
                    <div className='flex w-full items-center gap-2'>
                        <span className='w-32'>[예외신청내용]</span>
                        <input type="text" className='h-7' name="emmkMemo" value={exceptionParams.emmkMemo} onChange={handleInputChange} />
                        <button onClick={handleExceptionSubmit} className='search_btn bg_tr_primary w-24'>선택처리</button>
                    </div>
                </div>
                <div className='btn_container'>
                    <select name="itemsPerPage" value={pageInfo.itemsPerPage} onChange={handlePerPageChange}>
                        {perPageOptions.map(opt => <option key={opt} value={opt}>--{opt}건 씩 조회--</option>)}
                    </select>
                    <button onClick={handleSearch} disabled={isWholeLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                </div>
            </div>
            <div className='total_items mb-2'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</div>

            <div className='data_grid_container'>
                <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                <div className='data_list_table min-h-0 flex-grow'>
                    <table className={borderColorGray}>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={dataList.length > 0 && checkItems.length === dataList.length}
                                        onChange={(e) => handleAllCheck(e.target.checked)}
                                    />
                                </th>
                                {tableHeaders.map((h, i) => <th key={i}>{h}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {dataList.length === 0 ? (
                                <tr>
                                    <td colSpan={1000} className='empty_box'>
                                        <span className={`data_empty ${lightBackColor}`}>
                                            {isSearched ? <Icons.EmptyDalgu /> : <Icons.NullDalgu />}
                                            {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                dataList.map((item, index) => {
                                    const gridColor = index % 2 === 0 ? lightBackColor : '';
                                    return (
                                        <tr key={index} className={`${gridColor} ${hoverLightFontColor}`}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={checkItems.some(ci => ci.SEQ === item.SEQ)}
                                                    onChange={(e) => handleSingleCheck(e.target.checked, item)}
                                                />
                                            </td>
                                            {tableFields.map((field, i) => <td key={i}>{item[field]}</td>)}
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                    <hr className='mr-1-1 co_border_gray' />
                </div>
            </div>

            {dataList.length > 0 && <Pagination paginationInfo={{ ...pageInfo, onPageChange: handlePerPageChange }} />}

            <div className='mt-2'>
                <p className='co_red bold'> ※ 예외전송 기준 ※</p>
                <p>ㅇ 신청대상: 지난주 월요일부터 일요일까지의 내원일 기준 기간초과 오류데이터만</p>
                <p>ㅇ 신청기간: 매주 월요일부터 목요일 13시 까지</p>
                <p>ㅇ 전송가능기간: 매주 목요일 00-23:59, (*단 신청 후 승인 완료 된 건에 대해서만 전송 가능)</p>
            </div>
        </Main>
    );
};

export default BdExceptionAsk;
